import { HttpEvent } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { HttpEventsInterceptor } from "core/api";
import { NGXLogger } from 'ngx-logger';
import { Observable } from "rxjs";

@Injectable()
export class LogHttpEventsInterceptor extends HttpEventsInterceptor {


    readonly loggingMatchers = {
        urlMatchers: [
            ''
        ]
    }


    override intercept = (requestInfo: { body: any; params: any; url: string; }) => (obs: Observable<HttpEvent<any>>) =>
        obs


    constructor(
        private readonly _logger: NGXLogger
    ) {
        super();


    }


}